$(document).on('turbolinks:load', () => {
  // Check if on the Label Maker page
  if (!window.location.pathname.includes('/admin/labels')) {
    return;
  }
  console.log('initialize customer select');
  // Initialize Select2 for customer selection
  $('.versa-customer-select').select2(
    {
      theme: 'bootstrap-5',
      placeholder: 'Select Customer',
      allowClear: true,
      ajax: {
        url: '/admin/labels/customers',
        dataType: 'json',
        data:  (params) => {
          return {
            keyword: params.term, // search term
          };
        },
        processResults: (data) => {
          return {
            // Transforms the top-level key of the response to 'items'
            results: data.map( (customer) => {
              return {
                id: customer[0],
                text: customer[1],
              };
            }
            ),
          };
        },
        cache: true
      },
    }
  );
});
